import { CSSObject } from "@emotion/react";

export const resultsContainer: CSSObject = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  marginBottom: "100px",
  width: "100%",
};

export const loadMoreButtonCss = {
  root: {
    marginTop: "24px",
  },
};

export const searchResultsContainerCss = (isNewCardDesign: boolean) => ({
  width: "100%",
  display: "grid",
  gridTemplateColumns: isNewCardDesign
    ? "repeat(auto-fit, minmax(278px, 1fr))"
    : "repeat(auto-fit, minmax(246px, 1fr))",
  gap: "12px",
  paddingTop: "18px",

  // Applies to old content card designs. This can be removed when
  // experiment is released to 100%.
  "> div": {
    height: "auto",
  },

  // Applies to new content card designs.
  "> article": {
    minWidth: 0,
  },
});
